import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

const OptionalTextDivider: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        color: theme.colors.common.white,
        m: '1rem 0',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <Typography
          variant='h5'
          sx={{ color: theme.colors.common.bloomfieldGreen }}
        >
          {t('Optional', { ns: 'common' })}
        </Typography>
      </Box>
      <Divider sx={{ bgcolor: theme.colors.common.bloomfieldGreen }} />
    </Box>
  );
};

export default OptionalTextDivider;
